import { Link } from "react-router-dom";
import {
  Box,
  Divider,
  Drawer,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PhoneIphoneRoundedIcon from "@mui/icons-material/PhoneIphoneRounded";

import logoG from "../../../images/logoG.jpg";
import LessonDropdown from "./LessonDropdown/LessonDropdown";
import SearchComponent from "../../search/SearchComponent";
import "./LeftMobileMenu.css";
import "./responsive.css";

function LeftMobileMenu({ show, handleClose }) {
  return (
    <Drawer
      anchor="left"
      open={show}
      onClose={handleClose}
      ModalProps={{ keepMounted: true }}
      PaperProps={{ className: "mobile-menu" }}
    >
      <Box className="mobile-menu__header">
        <Link to="/home" onClick={handleClose} aria-label="Грамота, головна сторінка">
          <img alt="Грамота" src={logoG} />
        </Link>
        <IconButton onClick={handleClose} aria-label="Закрити меню">
          <CloseRoundedIcon />
        </IconButton>
      </Box>

      <Box className="mobile-menu__content">
        <SearchComponent onNavigate={handleClose} />
        <LessonDropdown onNavigate={handleClose} />
      </Box>

      <Divider />

      <Stack className="mobile-menu__support" spacing={1}>
        <Typography variant="subtitle2">Підтримка</Typography>
        <Stack component="a" href="tel:+380686604958" direction="row" spacing={1}>
          <PhoneIphoneRoundedIcon fontSize="small" />
          <span>+38 068 660 49 58</span>
        </Stack>
        <Stack component="a" href="mailto:info@gramota.kiev.ua" direction="row" spacing={1}>
          <EmailOutlinedIcon fontSize="small" />
          <span>info@gramota.kiev.ua</span>
        </Stack>
      </Stack>
    </Drawer>
  );
}

export default LeftMobileMenu;
